import api from './api';

export interface DashboardStats {
  totalTasks: number;
  completedTasks: number;
  inProgressTasks: number;
  overdueTasks: number;
  totalProjects: number;
  activeProjects: number;
  totalUsers: number;
  activeUsers: number;
  totalTimeLogged: number;
  thisWeekTimeLogged: number;
}

export interface UserProductivity {
  userId: string;
  userName: string;
  tasksCompleted: number;
  tasksInProgress: number;
  totalHoursLogged: number;
  averageTaskCompletionTime: number;
}

export interface ProjectReport {
  projectId: string;
  projectName: string;
  totalTasks: number;
  completedTasks: number;
  overdueTasks: number;
  progressPercentage: number;
  totalHoursLogged: number;
}

export interface GanttTask {
  id: string;
  title: string;
  startDate: string;
  dueDate: string;
  completedAt?: string;
  progress: number;
  assigneeName?: string;
  assigneeId?: string;
  parentTaskId?: string;
  projectId: string;
  projectName: string;
  statusName?: string;
  statusColor?: string;
  statusCategory?: string;
  priority: number;
  taskTypeName?: string;
  dependencies: string[];
}

export interface GanttAllFilters {
  projectId?: string;
  assigneeId?: string;
  teamId?: string;
  startDate?: string;
  endDate?: string;
}

// Get dashboard statistics
export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await api.get<DashboardStats>('/reports/dashboard');
  return response.data;
};

// Get user productivity report
export const getUserProductivity = async (startDate?: string, endDate?: string): Promise<UserProductivity[]> => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);

  const response = await api.get<UserProductivity[]>(`/reports/user-productivity?${params}`);
  return response.data;
};

// Get project reports
export const getProjectReports = async (): Promise<ProjectReport[]> => {
  const response = await api.get<ProjectReport[]>('/reports/project-reports');
  return response.data;
};

// Get Gantt chart data for a single project
export const getGanttData = async (projectId: string): Promise<GanttTask[]> => {
  const response = await api.get<GanttTask[]>(`/reports/gantt/${projectId}`);
  return response.data;
};

// Get Gantt chart data across all projects with filters
export const getGanttDataAll = async (filters?: GanttAllFilters): Promise<GanttTask[]> => {
  const params = new URLSearchParams();
  if (filters?.projectId) params.append('projectId', filters.projectId);
  if (filters?.assigneeId) params.append('assigneeId', filters.assigneeId);
  if (filters?.teamId) params.append('teamId', filters.teamId);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);

  const response = await api.get<GanttTask[]>(`/reports/gantt-all?${params}`);
  return response.data;
};
